export default __webpack_public_path__ + "static/media/mobile.432ca223.jpg";